import {
  CountryList,
  LegalList,
  Logo,
  LogoLinks,
  PriceHint,
  SoftwareLinks,
  TextLinks,
  CommercialRegister,
} from '../components';
import type { FooterProps } from '../types';

export function FooterDefault(props: FooterProps) {
  const { constants, softwareLinksSlot } = props;

  return (
    <>
      <TextLinks align="left" columns={5} direction="column" flow="column" {...props} />
      <LogoLinks align="center" columns={4} direction="row" flow="wrap" {...props} />
      {softwareLinksSlot ?? <SoftwareLinks align="center" columns={2} direction="row" flow="wrap" {...props} />}
      <CountryList constants={constants} />
      <PriceHint {...props} />
      <CommercialRegister constants={constants} />
      <LegalList {...props} />
      <Logo />
    </>
  );
}
